import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/deducciones-tipos-de-nominas-empleados';

/**
 * GET Deducciones Tipos de Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDeduccionesTiposDeNominasEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Deduccion Tipo de Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDeduccionTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Deduccion Tipo de Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDeduccionTipoDeNominaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Deduccion Tipo de Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDeduccionTipoDeNominaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Deduccion Tipo de Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDeduccionTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
